module.exports = __webpack_public_path__ + "4d2aea0940e4672c67bdcef5c6c8a867.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Hus/img/hus-sprite-roteramera.jpg
 ** module id = 470
 ** module chunks = 0
 **/